import { Routes, Route } from "react-router-dom";
import GlobalChatListener from "../components/global-chat-listener/GlobalChatListener";
import Main from '../pages/Layouts/Main/Main';
import Feed from '../pages/Feed/Feed';
import Games from '../pages/Games/Games';
import Game from '../pages/Game/Game';
import PostLikes from '../pages/Posts/PostLikes';
import NotFound from '../pages/errors/NotFound';
import Login from '../pages/Login/Login';
import ProtectedRoute from "./authenticated-routes";
import PostComments from "../pages/Posts/PostComments/PostComments";
import Account from "../pages/Account/Account";
import ProtectedRouteUnauthenticated from "./unauthenticated-routes";
import Settings from "../pages/Settings/Settings";
import MeaningStamps from "../pages/Settings/MeaningStamps/MeaningStamps";
import Guidelines from "../pages/Settings/guidelines";
import NotificationsSettings from "../pages/Settings/NotificationsSettings/NotificationsSettings";
import Donate from "../pages/Donate/Donate";
import Premium from "../pages/Premium/Premium";
import Download from "../pages/Download/Download";
import PacocaPapo from "../pages/PacocaPapo/PacocaPapo";
import Dashboard from "../pages/Dashboard/Dashboard";
import ViewPostScreen from "../pages/Posts/ViewPostScreen/ViewPostScreen";
import Notifications from "../pages/Notifications/Notifications";
import SearchScreen from "../pages/Settings/SearchScreen/SearchScreen";
import RegisterUser from "../pages/RegisterUser/RegisterUser";
import Communities from "../pages/Communities/Communities";
import ViewCommunity from "../pages/view-community/view-community";
import Accessibility from "../pages/Accessibility/Accessibility";
import PostCommentsResponses from "../pages/Posts/PostCommentsResponses/PostCommentsResponses";
import RegisterCommunity from "../pages/RegisterCommunity/RegisterCommunity";
import EditAccount from "../pages/EditAccount/EditAccount";
import PermissionsScreen from "../pages/Settings/PermissionsScreen/PermissionsScreen";
import Chat from "../pages/Chat/Chat";
import Flow from "../pages/Flow/Flow";
import Sessions from "../pages/Sessions/Sessions";
import MainMenu from "../pages/Layouts/Main/MainMenu";
import Hashtag from "../pages/Hashtag/Hashtag";
import VerifyEmail from "../pages/verify-email";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ForgotPassword from "../pages/forgot-password";
import Moderator from "../pages/Moderator/Moderator";
import Bans from "../pages/Moderator/Bans";
import FollowersScreen from "../pages/FollowersScreen/FollowersScreen";
import FollowingScreen from "../pages/FollowingScreen/FollowingScreen";
import Reposts from "../pages/Reposts/Reposts";
import ChatList from "../pages/Chat/ChatList";
import About from "../pages/About/About";
import DepriveProfile from "../pages/DepriveProfile";
import Privacy from "../pages/Settings/Privacy";
import UserBlocks from "../pages/Settings/UserBlocks";
import UserMutes from "../pages/Settings/UserMutes";
import ContentPreferences from "../pages/Settings/ContentPreferences";
import History from "../pages/blog/history";
import BlogHome from "../pages/blog";
import Tecnologies from "../pages/blog/tecnologies";
import Updates from "../pages/blog/updates";
import BlogArticle from "../pages/blog/article";
import BlogEditor from "../pages/blog/editor";
import BlogManage from "../pages/blog/manage";
import Ads from "../pages/ads";
import RegisterAds from "../pages/ads/register-ads";
import HowWorks from "../pages/ads/how-works";
import MyAds from "../pages/ads/my-ads";
import ViewAds from "../pages/ads/view-ads";
import Suport from "../pages/Settings/suport";
import TermsUseScreen from "../pages/Settings/terms-use-screen";
import AppVersion from "../pages/app-version";
import ViewMembers from "../pages/view-community/view-members";
import Requests from "../pages/Moderator/requests";
import CompanySealRequests from "../pages/Moderator/company-seal-requests";
import UsersWithBadges from "../pages/Moderator/users-with-badges";
import Design from "../pages/Settings/design";
import DeletedPosts from "../pages/Feed/deleted-posts";
import ModeratorRoute from "./moderator-routes";
import ModeratorOrBrownRoute from "./moderator-or-brown-route";
import WalletDeposit from "../pages/wallet/wallet-deposit";
import WalletScreen from "../pages/wallet/wallet";
import RetrospectivePage from "../pages/retrospective/RetrospectivePage";
import AddFrame from "../pages/frames/add-frame";
import ProfileFrames from "../pages/frames/profile-frames";
import AdsModerator from "../pages/Moderator/ads-moderator";
import ChildSafetyPolicy from "../pages/Settings/child-safety-policy";
import PrivacyPolicy from "../pages/Settings/privacy-policy";
import { RequestCompanySeal } from "../pages/companies/request-company-seal";
import MyStamps from "../pages/my-stamps";
import RankingScreen from "../pages/Settings/SearchScreen/ranking";
import UsersByIp from "../pages/Moderator/users-by-ip";
import Saveds from "../pages/Hashtag/saveds";
import Activate2fa from "../pages/2fa/activate-2fa";
import HiddenPosts from "../pages/Feed/hidden-posts";
import CancelSubscription from "../pages/Premium/cancel-subscription";
import PacocaAiPage from "../pages/blog/pacoca-ai";
import VotingUrn from "../pages/votes/preview-vote";
import ChatQuickRepliesSettings from "../pages/Settings/ChatQuickRepliesSettings";
import BrownStampRoute from "./brown-stamp-routes";
import GlobalPinnedPost from '../pages/Moderator/global-pinned-post';
import BroadcastPush from '../pages/Moderator/broadcast-push';
import PacocaPapoTesters from '../pages/Moderator/pacoca-papo-testers';
import Reactions from '../pages/Moderator/reactions';

// ProtectedRouteUnauthenticated = usuários logados não podem acessar
// ProtectedRoute = usuários deslogados não podem acessar

const App: React.FC = () => {
    return (
        <>
        <GlobalChatListener />
        <Routes>
            <Route path="/" element={<Main />}>
                <Route path="/" element={<MainMenu />}>
                    <Route index element={<Feed />} />
                    <Route path="/sobre" element={<About />} />
                    <Route path="/urna-votacao" element={<VotingUrn />} />
                    <Route path="/jogos" element={<Games />} />
                    <Route path="/jogos/:id" element={<Game />} />

                    <Route path="seguindo/:id" element={<ProtectedRoute><FollowingScreen /></ProtectedRoute>} />
                    <Route path="seguidores/:id" element={<ProtectedRoute><FollowersScreen /></ProtectedRoute>} />

                    <Route path="moderador" element={<ModeratorOrBrownRoute><Moderator /></ModeratorOrBrownRoute>} />
                    <Route path="moderador/banimentos" element={<ModeratorRoute><Bans /></ModeratorRoute>} />
                    <Route path="moderador/requisicoes" element={<ModeratorRoute><Requests /></ModeratorRoute>} />
                    <Route path="moderador/posts-excluidos" element={<ModeratorRoute><DeletedPosts /></ModeratorRoute>} />
                    <Route path="moderador/posts-ocultos" element={<ModeratorRoute><HiddenPosts /></ModeratorRoute>} />
                    <Route path="moderador/anuncios" element={<ModeratorRoute><AdsModerator /></ModeratorRoute>} />
                    <Route path="moderador/usuarios-por-ip/:ip" element={<ModeratorRoute><UsersByIp /></ModeratorRoute>} />
                    <Route path="usuarios-com-selos" element={<UsersWithBadges />}/>

                    <Route path="reposts/:id" element={<ProtectedRoute><Reposts /></ProtectedRoute>} />
                    <Route path="configuracoes" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="configuracoes/notificacoes" element={<ProtectedRoute><NotificationsSettings /></ProtectedRoute>} />
                    <Route path="configuracoes/respostas-rapidas" element={<ProtectedRoute><ChatQuickRepliesSettings /></ProtectedRoute>} />
                    <Route path="moderador/post-fixado" element={<BrownStampRoute><GlobalPinnedPost /></BrownStampRoute>} />
                    <Route path="moderador/emojis" element={<BrownStampRoute><Reactions /></BrownStampRoute>} />
                    <Route path="moderador/pacoca-papo" element={<BrownStampRoute><PacocaPapoTesters /></BrownStampRoute>} />
                    <Route path="moderador/push" element={<BrownStampRoute><BroadcastPush /></BrownStampRoute>} />
                    <Route path="moderador/solicitacoes-selo-empresa" element={<BrownStampRoute><CompanySealRequests /></BrownStampRoute>} />
                    <Route path="significado-selos" element={<MeaningStamps />} />
                    <Route path="meus-selos" element={<MyStamps />} />

                    <Route path="termos-uso" element={<TermsUseScreen />} />
                    <Route path="politica-privacidade" element={<PrivacyPolicy />} />
                    <Route path="diretrizes" element={<Guidelines />} />
                    <Route path="politica-seguranca-infantil" element={<ChildSafetyPolicy />} />

                    <Route path="design" element={<Design />} />
                    <Route path="suporte" element={<Suport />} />
                    <Route path="doacao" element={<Donate />} />
                    <Route path="verificado" element={<ProtectedRoute><Premium /></ProtectedRoute>} />
                    <Route path="assinatura" element={<ProtectedRoute><CancelSubscription /></ProtectedRoute>} />
                    <Route path="download" element={<Download />} />
                    <Route path="papo" element={<PacocaPapo />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="notificacoes" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                    <Route path="pesquisa" element={<ProtectedRoute><SearchScreen /></ProtectedRoute>} />
                    <Route path="ranking" element={<ProtectedRoute><RankingScreen /></ProtectedRoute>} />

                    <Route path="comunidades" element={<ProtectedRoute><Communities /></ProtectedRoute>} />
                    <Route path="comunidades/novo" element={<ProtectedRoute><RegisterCommunity /></ProtectedRoute>} />
                    <Route path="comunidades/:id" element={<ProtectedRoute><ViewCommunity /></ProtectedRoute>} />
                    <Route path="comunidades/editar/:id" element={<ProtectedRoute><RegisterCommunity /></ProtectedRoute>} />
                    <Route path="comunidades/membros/:id" element={<ProtectedRoute><ViewMembers /></ProtectedRoute>} />

                    <Route path="acessibilidade" element={<Accessibility />} />
                    <Route path="conta" element={<ProtectedRoute><EditAccount /></ProtectedRoute>} />
                    <Route path="permissoes/:id" element={<ModeratorRoute><PermissionsScreen /></ModeratorRoute>} />
                    <Route path="post/curtidas/:id" element={<ProtectedRoute><PostLikes /></ProtectedRoute>} />
                    <Route path="post/hashtag/:hashtag" element={<ProtectedRoute><Hashtag /></ProtectedRoute>} />
                    <Route path="post/salvos" element={<ProtectedRoute><Saveds /></ProtectedRoute>} />
                    <Route path="meus-dispositivos" element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
                    <Route path="sessoes-ativas" element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
                    <Route path="privacidade" element={<ProtectedRoute><Privacy /></ProtectedRoute>} />
                    <Route path="privacidade/visibilidade-perfil" element={<ProtectedRoute><DepriveProfile /></ProtectedRoute>} />
                    <Route path="privacidade/bloqueados" element={<ProtectedRoute><UserBlocks /></ProtectedRoute>} />
                    <Route path="privacidade/ocultos" element={<ProtectedRoute><UserMutes /></ProtectedRoute>} />
                    <Route path="privacidade/conteudo" element={<ProtectedRoute><ContentPreferences /></ProtectedRoute>} />
                    <Route path="post/:id" element={<ProtectedRoute><ViewPostScreen /></ProtectedRoute>} />
                    <Route path="verificar-email" element={<VerifyEmail />} />
                    <Route path="*" element={<NotFound />} />
                    <Route path="/chats" element={<ProtectedRoute><ChatList /></ProtectedRoute>} />
 
                    <Route path="/2fa" element={<ProtectedRoute><Activate2fa /></ProtectedRoute>} />
                    
                    <Route path="/carteira" element={<ProtectedRoute><WalletScreen /></ProtectedRoute>} />
                    <Route path="/carteira/deposito" element={<ProtectedRoute><WalletDeposit /></ProtectedRoute>} />

                    <Route path="/retrospectiva/compartilhada/:userId/:year" element={<RetrospectivePage />} />
                    <Route path="/retrospectiva" element={<ProtectedRoute><RetrospectivePage /></ProtectedRoute>} />
                    
                    <Route path="/molduras/criar" element={<ModeratorRoute><AddFrame /></ModeratorRoute>} />
                    <Route path="/molduras" element={<ProtectedRoute><ProfileFrames /></ProtectedRoute>} />
                    <Route path="/molduras/:id" element={<ModeratorRoute><AddFrame /></ModeratorRoute>} />

                    <Route path="versao-do-app" element={<AppVersion />} />

                    <Route path="/anuncios" element={<Ads />} />
                    <Route path="/anuncios/novo" element={<ProtectedRoute><RegisterAds /></ProtectedRoute>} />
                    <Route path="/anuncios/como-funciona" element={<HowWorks />} />
                    <Route path="/anuncios/meus-anuncios" element={<MyAds />} />
                    <Route path="/anuncios/meus-anuncios/:id" element={<ViewAds />} />

                    <Route path="/empresas/solicitar-selo" element={<RequestCompanySeal />} />
                </Route>

                {/* Blog (sem NavbarMobile / ChatGlobal) */}
                <Route path="/blog" element={<BlogHome />} />
                <Route path="/blog/escrever" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
                <Route path="/blog/editar/:id" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
                <Route path="/blog/gerenciar" element={<ProtectedRoute><BlogManage /></ProtectedRoute>} />
                <Route path="/blog/artigo/:slug" element={<BlogArticle />} />
                <Route path="/blog/historia" element={<History />} />
                <Route path="/blog/atualizacoes" element={<Updates />} />
                <Route path="/blog/pacoca-ai" element={<PacocaAiPage />} />
                <Route path="/blog/tecnologias" element={<Tecnologies />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />

                <Route path="esqueci-minha-senha" element={<ForgotPassword />} />
                <Route path="resetar-senha" element={<ResetPassword />} />

                <Route path="post/comentarios/:id" element={<ProtectedRoute><PostComments /></ProtectedRoute>} />
                <Route path="post/comentarios/respostas/:id" element={<ProtectedRoute><PostCommentsResponses /></ProtectedRoute>} />

                <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
                <Route path="/chat/:id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />

                <Route path="/flow" element={<ProtectedRoute><Flow /></ProtectedRoute>} />
                <Route path="/flow/:reelId" element={<Flow />} />

                <Route path="/" element={<MainMenu />}>
                    <Route path="/:user_name" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                </Route>

                {/* não pode estar logado */}
                <Route path="login" element={<Login />} />
                <Route path="cadastro" element={<RegisterUser />} />
            </Route>
        </Routes>
        </>
    );
};

export default App;